export default function Safety(){

    return(
        <section id="section-2" className="div-flex">
            <div className="image-safety div_flex_reverse_image"></div>
            <div className="div_flex_reverse_text_button" >
                <div className="div_flex_reverse_text">
                    <h4>Safety</h4>
                    <h1>Built for Safety</h1>
                    <p>
                        Safety is the most important part of every Tesla. We design our vehicles to exceed safety standard.
                        <br/>
                        <br/>
                        5-Star Rating<br/>
                        Model 3 achieved NHTSA 5-star safety ratings in every category and subcategory.
                        <br/>
                        <br/>
                        Top Safety Pick+<br/>
                        Model 3 received the IIHS Top Safety Pick+ award, with top ratings in all crashworthiness and <br/> crash prevention categories.
                    </p>
                </div>
                <div>
                    <div className="div-learn-more" style={{marginBottom: '10px'}}>
                        <a href="#" className="btn-learn-more">+</a>
                        <p>Learn More</p>
                    </div>
                    <button href="#" className="btn-border-black">Order Now</button>
                </div>
            </div>
        </section>
    )
}